import styles from './Spinner.module.css'

export function Spinner() {
  return <div role="presentation" className={styles.Spinner} />
}
